import { render, staticRenderFns } from "./CreateDuplicationModal.vue?vue&type=template&id=96327f88&scoped=true&"
import script from "./CreateDuplicationModal.vue?vue&type=script&lang=ts&"
export * from "./CreateDuplicationModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateDuplicationModal.vue?vue&type=style&index=0&id=96327f88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96327f88",
  null
  
)

export default component.exports